import request from '@/utils/request'

export function getRelatedLegisChecklist (params, isProgress) {
  return request({
    url: `/api/getRelatedLegisChecklist`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    data: params,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

export function saveRelatedLegisChecklist (params, isProgress) {
  return request({
    url: `/api/saveRelatedLegisChecklist`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    data: params,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isProgress, apitype: 'saved' },
  })
}
export function deleteRelatedLegisChecklist (params, isProgress) {
  return request({
    url: `/api/deleteRelatedLegisChecklist`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    data: params,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isProgress, apitype: 'deleted' },
  })
}

export function getRelatedLegisChecklistReport(params, isNotify=false) {
  let responseType = "blob"
  return request({
    url: '/api/getRelatedLegisChecklistReport',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    responseType: responseType,
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}